import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { style: {"width":"60%"} }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "ma-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_carousel = _resolveComponent("carousel")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "pa-0 mx-0" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { class: "ma-0" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "6",
            class: "pa-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                class: "ma-0",
                align: "center",
                style: {"min-height":"100vh"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("img", {
                      src: '/files/logo-' + _ctx.$vuetify.theme.name + '.png',
                      width: "80px",
                      class: "mb-4"
                    }, null, 8, _hoisted_2),
                    _createVNode(_component_v_card_title, { class: "px-0" }, {
                      default: _withCtx(() => _cache[3] || (_cache[3] = [
                        _createTextVNode(" Inicia sesión en tu cuenta ")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_card_subtitle, { class: "px-0 mb-6" }, {
                      default: _withCtx(() => _cache[4] || (_cache[4] = [
                        _createTextVNode(" Accede a tu panel y continúa donde te quedaste ")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_form, {
                      onSubmit: _withModifiers(_ctx.login, ["prevent"]),
                      style: {"width":"100%"},
                      class: "login-form"
                    }, {
                      default: _withCtx(() => [
                        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-subtitle-1 text-medium-emphasis" }, "Usuario", -1)),
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.email,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                          variant: "underlined"
                        }, null, 8, ["modelValue"]),
                        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-subtitle-1 text-medium-emphasis d-flex align-center justify-space-between" }, [
                          _createTextVNode(" Contraseña "),
                          _createElementVNode("a", {
                            class: "text-caption text-decoration-none",
                            href: "/forgot-password",
                            rel: "noopener noreferrer"
                          }, " ¿Olvidaste tu contraseña? ")
                        ], -1)),
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.password,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                          "append-inner-icon": _ctx.visible ? 'mdi-eye-off' : 'mdi-eye',
                          type: _ctx.visible ? 'text' : 'password',
                          variant: "underlined",
                          "onClick:appendInner": _cache[2] || (_cache[2] = ($event: any) => (_ctx.visible = !_ctx.visible))
                        }, null, 8, ["modelValue", "append-inner-icon", "type"]),
                        _createVNode(_component_v_btn, {
                          type: "submit",
                          color: "primary",
                          block: "",
                          style: {"text-transform":"none"}
                        }, {
                          default: _withCtx(() => _cache[5] || (_cache[5] = [
                            _createTextVNode("Login")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["onSubmit"]),
                    (_ctx.error)
                      ? (_openBlock(), _createBlock(_component_v_alert, {
                          key: 0,
                          type: "error",
                          class: "mt-4",
                          small: "",
                          style: {"width":"100%","font-size":"13px","padding":"10px"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.error), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_row, {
                      align: "center",
                      class: "my-6 mx-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_divider)
                          ]),
                          _: 1
                        }),
                        _cache[8] || (_cache[8] = _createElementVNode("span", { class: "mx-2" }, "O", -1)),
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_divider)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      class: "mt-4",
                      variant: "outlined",
                      block: ""
                    }, {
                      default: _withCtx(() => _cache[9] || (_cache[9] = [
                        _createElementVNode("img", {
                          width: "14px",
                          class: "mr-2",
                          src: "/files/google.svg"
                        }, null, -1),
                        _createElementVNode("span", { style: {"text-transform":"none"} }, "Iniciar Sesión con Google", -1)
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      class: "mt-4",
                      variant: "outlined",
                      block: ""
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          width: "14px",
                          class: "mr-2",
                          src: "/files/X.svg",
                          style: _normalizeStyle(_ctx.$vuetify.theme.name=='dark'?'filter:invert(1);':'')
                        }, null, 4),
                        _cache[10] || (_cache[10] = _createElementVNode("span", { style: {"text-transform":"none"} }, "Iniciar Sesión con X", -1))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_subtitle, {
                      class: "mt-6",
                      style: {"text-align":"center"}
                    }, {
                      default: _withCtx(() => _cache[11] || (_cache[11] = [
                        _createTextVNode(" ¿Aún no tienes una cuenta? "),
                        _createElementVNode("a", {
                          class: "text-decoration-none",
                          href: "/register",
                          rel: "noopener noreferrer"
                        }, "Regístrate gratis", -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_v_spacer)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            class: "mr-6 my-6 d-flex flex-column justify-space-between",
            style: _normalizeStyle('background:url(/files/login-' + _ctx.$vuetify.theme.name + '.png); background-repeat: no-repeat; background-size: cover; border-radius:40px 0px 40px 0px;')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("img", {
                  src: '/files/isotipo-' + _ctx.$vuetify.theme.name + '.svg',
                  width: "30px",
                  class: "ma-12"
                }, null, 8, _hoisted_3)
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_carousel)
              ])
            ]),
            _: 1
          }, 8, ["style"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}